import { apiHandler } from '../api/apihandler';
import { TRANSLATION_LANGUAGES } from '../api/constants';

export const DEFAULT_TRANSLATION_LANGUAGE = {
    code: 'en',
    label: 'English'
};

let translationLanguagesCache = null;
let translationLanguagesPromise = null;

function createCachedTranslationResponse(languages) {
    return {
        data: {
            response: {
                status: 200,
                message: 'OK',
            },
            data: {
                languages,
                total: languages.length,
            },
        },
    };
}

export function normalizeTranslationLanguages(languages = []) {
    if (!Array.isArray(languages)) {
        return [];
    }

    const normalizedLanguages = [];
    const seenCodes = new Set();

    languages.forEach((language) => {
        const code = String(language?.code || '').trim();
        const label = String(language?.label || code || '').trim();

        if (!code || !label) {
            return;
        }

        const normalizedCode = code.toLowerCase();
        if (seenCodes.has(normalizedCode)) {
            return;
        }

        seenCodes.add(normalizedCode);
        normalizedLanguages.push({
            ...language,
            code,
            label,
        });
    });

    return normalizedLanguages;
}

export async function fetchTranslationLanguages() {
    if (translationLanguagesCache) {
        return {
            response: createCachedTranslationResponse(translationLanguagesCache),
            languages: translationLanguagesCache,
        };
    }

    if (!translationLanguagesPromise) {
        translationLanguagesPromise = apiHandler(TRANSLATION_LANGUAGES, 'GET')
            .then((response) => {
                const languages = normalizeTranslationLanguages(response?.data?.data?.languages);
                translationLanguagesCache = languages;
                return {
                    response,
                    languages,
                };
            })
            .finally(() => {
                translationLanguagesPromise = null;
            });
    }

    return translationLanguagesPromise;
}
